var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-xl-6 xl-100"},[_c('div',{staticClass:"order-graph xl-space"},[_c('h6',[_vm._v("Revenue for last month")]),_c('div',{staticClass:"ct-4 flot-chart-container"},[_c('apexchart',{attrs:{"type":"area","height":"400","options":_vm.chartOptions,"series":_vm.series}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }